import createLeadQuery from './createLead.graphql';
import { sendTosaRequest } from './sendTosaRequest';

import type { CreateLeadMutation, CreateLeadMutationVariables } from './types';

type Mutation = CreateLeadMutation;
type Variables = CreateLeadMutationVariables;

export async function createLead({ email }: Variables) {
  return sendTosaRequest<Variables, Mutation>({
    query: createLeadQuery,
    variables: {
      email,
    },
  });
}
